import { storeToRefs } from 'pinia';

export function useReferral() {
    const { authed, tenant } = storeToRefs(useAuthStore());
    const referralLink = computed(() => tenant.value?.referralLink ?? '');

    const hasReferralAccess = computed(() => (authed.value?.hasPermission('app:referral') && referralLink.value) ?? false);

    return { hasReferralAccess, referralLink };
}
